module.exports = __webpack_public_path__ + "img/curve_sm_2.92c65ac1.svg";